var _path, _g, _path2, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIndonesia(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 21,
    viewBox: "0 0 34 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_11472_38868",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: -1,
    y: 0,
    width: 35,
    height: 21
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M33.5571 0.804688H-0.00390625V20.3827H33.5571V0.804688Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_11472_38868)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M33.5571 0.804688H-0.00390625V10.5937H33.5571V0.804688Z",
    fill: "#BC0030"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_11472_38868",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: -1,
    y: 0,
    width: 35,
    height: 21
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M33.5571 0.804688H-0.00390625V20.3827H33.5571V0.804688Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_11472_38868)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M33.5571 10.5938H-0.00390625V20.3828H33.5571V10.5938Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIndonesia);
export default __webpack_public_path__ + "static/media/INDONESIA.c416e9b58f0e7809d60437135f5f4539.svg";
export { ForwardRef as ReactComponent };